import { Skeleton, Text, Flex } from '@chakra-ui/react';
import { useResources } from 'datx-jsonapi-react';
import { FC } from 'react';

import { queryKeywordsByLectureId } from '@/fetchers/keywords';
import { ThinLecture } from '@/resources/ThinLecture';

interface ILectureKeywordsProps {
  data: ThinLecture;
}

export const LectureKeywords: FC<ILectureKeywordsProps> = ({ data: lecture }) => {
  const { data: keywords, error } = useResources(queryKeywordsByLectureId(lecture.id));

  if (error) {
    throw error;
  }

  if (keywords?.length === 0) {
    return null;
  }

  return (
    <Flex gap={2} overflowY="hidden" h="38px" alignItems="baseline" flexWrap="wrap">
      {!keywords && Array.from({ length: 2 }).map((_, i) => <Skeleton key={i} h={8} borderRadius="100px" w={16} />)}
      {keywords &&
        keywords.map(({ name }) => (
          <Text noOfLines={1} borderColor="black" borderWidth="1px" px="2" py="1" borderRadius="100px" key={name}>
            {name}
          </Text>
        ))}
    </Flex>
  );
};
